(function($){
  $(document).on('mouseenter', 'summary.header__menu-item', function(e){
      $('details.mega-menu').removeAttr('open');
      $(this).trigger('click');
  });
  $(document).on('mouseenter', 'a.header__menu-item', function(e){
      $('details.mega-menu').removeAttr('open');
  });
  $("details.mega-menu").bind("DOMSubtreeModified", function() {
    var attr = $(this)[0].hasAttribute('open');
    if (attr) {
        $('.header-wrapper').addClass('details-open');
    }else{
        $('.header-wrapper').removeClass('details-open');
    }
  });
  $(document).on('mouseleave', 'sticky-header.header-wrapper', function(e){
      console.log('header-wrapper mouseleave');
    $('details.mega-menu').removeAttr('open');
  });
  // $(document).on('mouseleave', '.mega-menu__content', function(e){
  //     console.log('mega-menu mouseleave');
  // });
  // $(document).on('mouseenter', 'sticky-header.header-wrapper', function(e){
  //   // console.log('header-wrapper mouseenter');
  // });
  // $(document).on('mouseenter', '.mega-menu__content', function(e){
  //   console.log('mega-menu mouseenter');
  // });
  $(document).on('change', '.custom-quick-add', function(e){
    let selected = $(this).find('input[type="radio"]:checked').val();
    let parent = $(this).parent();
    let variant = parent.find('.product-variant-price').find(`.product-variant-${selected}`);
    if (variant.length != 0) {
      let id = variant.data('id');
      parent.find('product-form form input[name="id"]').val(id);
    }
  });
})(jQuery);